import { render, staticRenderFns } from "./orderPay.vue?vue&type=template&id=7e71ef87&"
import script from "./orderPay.vue?vue&type=script&lang=js&"
export * from "./orderPay.vue?vue&type=script&lang=js&"
import style0 from "./orderPay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports